module.exports = __webpack_public_path__ + "static/media/zvony3.cfd413b8.jpg";